import { Component, inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { CommonModule } from '@angular/common';

import { UserService } from '../shared/services/user.service';
import { NewsItem, NewsService } from '../shared/services/news.service';

export const newsResolver: ResolveFn<void> = () => {
  inject(UserService).set('unreadNews', 0);
}

@Component({
  selector: 'app-news',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './news.component.html',
  styleUrl: './news.component.scss'
})
export class NewsComponent {
  private newsService = inject(NewsService);
  public newsItems: NewsItem[] = [];
  loading = true;

  constructor() {
    this.newsService.getNews().subscribe(newsItems => {
      this.newsItems = newsItems;
      this.loading = false;
    });
  }
}
